import React from 'react';

export default function TaskSummary({ counts }) {
  const cards = [
    { key: 'pending',      label: 'Pending',     mod: 'pending'  },
    { key: 'in-progress',  label: 'In Progress', mod: 'progress' },
    { key: 'completed',    label: 'Completed',   mod: 'done'     },
    { key: 'urgent',       label: 'Urgent',      mod: 'urgent'   },
  ];

  return (
    <div className="tasks-summary">
      {cards.map(({ key, label, mod }) => (
        <div key={key} className={`tasks-summary__card tasks-summary__card--${mod}`}>
          <span className="tasks-summary__num">{counts[key]}</span>
          <span className="tasks-summary__lbl">{label}</span>
        </div>
      ))}
    </div>
  );
}
